
export function experiments_get(token,urlprefix){
    return fetch(urlprefix + `api/experiments`, {
        method: 'GET',
        headers: {
       'Content-Type': 'application/json',
        'Accept': 'application/json',
       'Authorization': 'Bearer '+ token}
    })
};

export function experiments_post(data,token,urlprefix,experiment){
    return fetch(urlprefix + `api/experiment/?experiment=`+experiment, {
        method: 'POST',
        body: data,
        headers: {
       'Content-Type': 'application/json',
        'Accept': 'application/json',
       'Authorization': 'Bearer '+ token}
    })
};


export function experiments_view(token,urlprefix,data){
    return fetch(urlprefix + `api/experimentsview/`, {
        method: 'POST',
        body: data,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
    })
};


export function experiment_get(token,urlprefix,experiment){
    return fetch(urlprefix + `api/experiment/?experiment=`+experiment, {
        method: 'GET',
        headers: {
       'Content-Type': 'application/json',
        'Accept': 'application/json',
       'Authorization': 'Bearer '+ token}
    })
};


export function files_view(token,urlprefix,data){
    return fetch(urlprefix + `api/filesview/`, {
        method: 'POST',
        body: data,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export function statics_data_access(token,urlprefix){
    return fetch(urlprefix + `api/dataccestats/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export function detailed_data_access(token,urlprefix,data){
  return fetch(urlprefix + `api/specificdataccestats/`, {
      method: 'POST',
      body: data,
      headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer '+ token},
      })
}

export function analyzed_experiments(token,urlprefix){
    return fetch(urlprefix + `api/getanalyzedexperiments/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export function tagged_variants(token,urlprefix,experiment){
    return fetch(urlprefix + `api/gettaggedvariants/?experiment=` + experiment, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};


export function get_tagged_from_phenostore(token, urlprefix){
    return fetch(urlprefix + "/get_all_variants", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': token},
    })
}

export function get_participant_variant(token, urlprefix, par_id){
    return fetch(urlprefix + "/participant/tag_variants/"+ par_id, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': token},
    })
}

export function sequencing_center(token,urlprefix){
    return fetch(urlprefix + `api/seqcentre/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export async function file_update(token,urlprefix,data){
   return fetch(urlprefix + `api/fileupdate/`, {
      method: 'POST',
      body: data,
      headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'connection': 'keep-alive',
          'Authorization': 'Bearer '+ token},
      })
};

export function project_list(token,urlprefix){
    return fetch(urlprefix + `api/projectlist/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export function get_project(token,urlprefix,project){
    return fetch(urlprefix + `api/projects/?project_title=` + project, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export function subproject_list(token,urlprefix){
    return fetch(urlprefix + `api/subprojectlist/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export function erns_list(token,urlprefix){
    return fetch(urlprefix + `api/ernlist/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export function tissue_list(token,urlprefix){
    return fetch(urlprefix + `api/tissuelist/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export function kit_list(token,urlprefix){
    return fetch(urlprefix + `api/kitlist/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export function group_list(token,urlprefix){
    return fetch(urlprefix + `api/groups/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export async function experiment_create(token,urlprefix,data){
  return fetch(urlprefix + `api/experimentcreate/`, {
     method: 'POST',
     body: data,
     headers: {
         'Content-Type': 'application/json',
         'Accept': 'application/json',
         'connection': 'keep-alive',
         'Authorization': 'Bearer '+ token},
     })
};


export function action_list(token,urlprefix,action){
    return fetch(urlprefix + `api/` + action, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        });
};

export async function action_update(token,urlprefix,query,method){
   return fetch(urlprefix + `api/` + query, {
      method: method,
      headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'connection': 'keep-alive',
          'Authorization': 'Bearer '+ token},
      })
};

export function experiment_status(token,urlprefix,experiment){
    return fetch(urlprefix + `api/statusbyexperiment/?experiment=` + experiment + `&timestamp=true`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export function experiment_information(token,urlprefix,experiment){
    return fetch(urlprefix + `api/experimentinformation/?experiment=` + experiment, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export function participant_list(token,url_phenostore,data){
     return fetch(url_phenostore + "/participants", {
         method: 'POST',
         body: data,
         headers: {
             'Content-Type': 'application/json',
             'Accept': 'application/json',
             'Authorization': token},
     })
 };

 export function download_excel(token,urlprefix,data,excel_name){
      return fetch(urlprefix + `api/downloadexcel/`, {
          method: 'POST',
          body: data,
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': 'Bearer '+ token},
      }).then(res => {
          return res.blob();
      }).then(blob => {
          const href = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = href;
          a.setAttribute('download', excel_name);
          document.body.appendChild(a);
          a.click();
      }).catch(err => console.error(err));
};

export function asperashares(token,urlprefix){
    return fetch(urlprefix + `api/asperashares/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
        })
};

export function asperafilesinformation(token,url_prefix,data){
     return fetch(url_prefix + `api/asperafilesinformation/`, {
         method: 'POST',
         body: data,
         headers: {
             'Content-Type': 'application/json',
             'Accept': 'application/json',
             'Authorization': 'Bearer '+ token},
     })
};

export function getOMIMInfo(urlprefix, string, token){

    return fetch( urlprefix + "/cors_omim/" + string,

        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                "X-TOKEN-AUTH": token,
                /* 'Content-Type': "application/json; charset=UTF-8",*/
            }}
    )
}


export function asperaexperimentsinformation(token,url_prefix,data){
     return fetch(url_prefix + `api/asperaexperimentsinformation/`, {
         method: 'POST',
         body: data,
         headers: {
             'Content-Type': 'application/json',
             'Accept': 'application/json',
             'Authorization': 'Bearer '+ token},
     })
};

export function status_list(token,url_prefix,data){
     return fetch(url_prefix + `api/statuslist/`, {
         method: 'POST',
         body: data,
         headers: {
             'Content-Type': 'application/json',
             'Accept': 'application/json',
             'Authorization': 'Bearer '+ token},
     })
};

export function status_list_experiments(token,url_prefix,data,experiments){
     return fetch(url_prefix + `api/statuslist/?experiments=` + experiments.join(","), {
         method: 'POST',
         body: data,
         headers: {
             'Content-Type': 'application/json',
             'Accept': 'application/json',
             'Authorization': 'Bearer '+ token},
     })
};



export function files_by_experiment(token,urlprefix,experiment){
     return fetch(urlprefix + `api/filesbyexperiment/?experiment_id=` + experiment, {
         method: 'GET',
         headers: {
             'Content-Type': 'application/json',
             'Accept': 'application/json',
             'Authorization': 'Bearer '+ token},
         })
};

export function experiments_no_files(token,urlprefix,data){
     return fetch(urlprefix + `api/experimentnofiles/`, {
         method: 'POST',
         body: data,
         headers: {
             'Content-Type': 'application/json',
             'Accept': 'application/json',
             'Authorization': 'Bearer '+ token},
     })
};

export function send_mail(token,urlprefix,data){
     return fetch(urlprefix + `api/sendmail/`, {
         method: 'POST',
         body: data,
         headers: {
             'Content-Type': 'application/json',
             'Accept': 'application/json',
             'Authorization': 'Bearer '+ token},
     })
};

export function experiments_being_analysed(token,urlprefix){
     return fetch(urlprefix + `api/experimentsbeinganalysed/`, {
         method: 'GET',
         headers: {
             'Content-Type': 'application/json',
             'Accept': 'application/json',
             'Authorization': 'Bearer '+ token},
     })
};

export function status_filter(token,url_prefix,data){
    return fetch(url_prefix + `api/statusfilter/`, {
        method: 'POST',
        body: data,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
    })
};

export function cram_reference_list(token,urlprefix){
    return fetch(urlprefix + `api/cramreference`, {
        method: 'GET',
        headers: {
       'Content-Type': 'application/json',
        'Accept': 'application/json',
       'Authorization': 'Bearer '+ token}
    })
};

export function get_qc_metrics(token,url_prefix,data){
    return fetch(url_prefix + `api/getqcmetrics/`, {
        method: 'POST',
        body: data,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
    })
};


export function file_status(token,url_prefix,data){
    return fetch(url_prefix + `api/filesstatus/`, {
        method: 'POST',
        body: data,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
    })
};


export function closefilesubmission(token,url_prefix,data){
    return fetch(url_prefix + `api/closefilesubmission/`, {
        method: 'POST',
        body: data,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ token},
    })
};
